export default __webpack_public_path__ + "static/media/2_magic 2.c7077493.png";